import isNumber from 'lodash/isNumber'

const concatAttr = (value, unit) => (isNumber(value) ? `${value}${unit || ''}` : value)

export const setDefault = (value, defaultValue, unit, defaultUnit) =>
  value !== undefined && value !== null ? concatAttr(value, unit) : concatAttr(defaultValue, defaultUnit)
